require('./RASuitabilityTestStatusView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @components
const RASuitabilityTestExpired = require('../../components/RASuitabilityTestExpired/RASuitabilityTestExpired');
const RASuitabilityTestValid = require('../../components/RASuitabilityTestValid/RASuitabilityTestValid');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const RACover = require('../../components/commons/RACover/RACover');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { recordLink } = require('utilities/tagging');
const { isTestExpired } = require('../../utilities/RASuitabilityTestHelper');

// @actions
const raSuitabilityTestActions = require('../../actions/RASuitabilityTest');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');

// @constants
const {
    GLOBAL_TRACKING_URL_PARA,
    GOAL_TRACKING_URL,
    MYPROFILE_BROKER_ROBO_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    PROC_RA_SUITABILITY_TEST_STATUS,
    PROC_RA_GO_BACK,
    SUITABILITY_TEST_URL,
    RA_SUITABILITY_TEST_STATUS,
} = require('../../raConstants/index');
const { MODIFY_SUITABILITY_TEST } = require('constants/flagBasedFeatures');

class RASuitabilityTestStatusView extends React.Component {
    constructor(props) {
        super(props);

        this.handleRetakeTestButtonClick = this.handleRetakeTestButtonClick.bind(
            this,
        );
        this.handleRetryTestClick = this.handleRetryTestClick.bind(this);
    }

    componentDidMount() {
        this.props.getHistoricalTest();
        this.props.fetchFeatureFlag();
    }

    handleRetryTestClick() {
        const { enableRetryTest, setOrigin } = this.props;
        enableRetryTest();
        setOrigin(RA_SUITABILITY_TEST_STATUS);
    }

    buildBreadcrumb() {
        const { immRAGlobalPosition } = this.props;
        const origin = immRAGlobalPosition.get('originRedirection');
        let aditionalStepText;
        let aditionalStepUrl;
        if (origin === PORTFOLIO_TRACK_URL_PARA) {
            aditionalStepText = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            aditionalStepUrl = `${PORTFOLIO_TRACKING_URL}/${immRAGlobalPosition.get(
                'idRedirection',
            )}`;
        } else if (origin === OBJECTIVE_TRACK_URL_PARA) {
            aditionalStepText = formatText(
                'breadcrumb-breadcrumb_objectiveTracking',
            );
            aditionalStepUrl = `${GOAL_TRACKING_URL}/${immRAGlobalPosition.get(
                'idRedirection',
            )}`;
        }
        return [
            {
                text: formatText('raSuitabilityTestStatus-investments'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText(
                    'raSuitabilityTestStatus-roboAdvisorBreadcrumb',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            ...(origin !== GLOBAL_TRACKING_URL_PARA
                ? [
                      {
                          text: aditionalStepText,
                          url: aditionalStepUrl,
                      },
                  ]
                : []),
            {
                text: formatText('raSuitabilityTestStatus-headerTitle'),
            },
        ];
    }

    buildContent() {
        const {
            immProfile,
            immSuitabilityTest,
            immCheckStatus,
            immFlagBasedFeatures,
            immRAFeatureFlag,
            featureModalToggle,
            buttonRenewClicked,
            setOrigin,
        } = this.props;
        const isFetching =
            immSuitabilityTest.get('isFetchingHistoricalTests') ||
            immRAFeatureFlag.get('isFetching');
        const alreadyFetched = immSuitabilityTest.get('fetchedHistoricalTest');

        if (isFetching || !alreadyFetched) {
            return <LoadingSection />;
        }

        const email = PersonalDataHelper.getEmail(immProfile);
        const immResult = immSuitabilityTest.getIn(['results', 0]);
        const date = moment(immResult.get('signed'));
        const isExpired = this.isExpired();
        const clientRiskProfile = immResult.get('clientRiskProfileTitle');
        const clientRiskProfileDescription = immResult.get(
            'clientRiskProfileDescription',
        );
        const clientSustainabilityProfileDescription = immResult.get(
            'sustainabilityProfileDescription',
        );
        const productDescription = immResult.get('maxTypeOfProductDescription');
        const retryMainText = immSuitabilityTest.get('retryMainText');
        const retrySecondaryText = immSuitabilityTest.get('retrySecondaryText');
        const retryTitle = immSuitabilityTest.get('retryTitle');

        if (isExpired) {
            return (
                <RASuitabilityTestExpired
                    date={date}
                    email={email}
                    clientRiskProfile={clientRiskProfile}
                    clientRiskProfileDescription={clientRiskProfileDescription}
                    productDescription={productDescription}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    buttonRenewClicked={buttonRenewClicked}
                    setOrigin={setOrigin}
                />
            );
        } else {
            return (
                <RASuitabilityTestValid
                    date={date}
                    email={email}
                    clientRiskProfile={clientRiskProfile}
                    clientRiskProfileDescription={clientRiskProfileDescription}
                    productDescription={productDescription}
                    onRetryTestClick={this.handleRetryTestClick}
                    retryMainText={retryMainText}
                    retrySecondaryText={retrySecondaryText}
                    retryTitle={retryTitle}
                    immCheckStatus={immCheckStatus}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immRAFeatureFlag={immRAFeatureFlag}
                    featureModalToggle={featureModalToggle}
                    clientSustainabilityProfileDescription={
                        clientSustainabilityProfileDescription
                    }
                />
            );
        }
    }

    isExpired() {
        const { immCheckStatus, immSuitabilityTest } = this.props;
        const isExpired = isTestExpired(immCheckStatus);
        return (
            isExpired || !immSuitabilityTest.getIn(['results', 0, 'testValid'])
        );
    }

    handleRetakeTestButtonClick() {
        this.props.history.push(SUITABILITY_TEST_URL);
    }

    handleBackClick() {
        recordLink(PROC_RA_SUITABILITY_TEST_STATUS, PROC_RA_GO_BACK);
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    buildCoverRightContent() {
        return (
            <div>
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-anterior"
                    inverse={true}
                    onClick={() => this.handleBackClick()}
                >
                    <FormattedText
                        value="buttonsActions-goBack"
                        format="firstUppercase"
                    />
                </OKButton>
            </div>
        );
    }

    buildHelpContent() {
        const { immSuitabilityTest } = this.props;
        const isFetchingHistoricalTests = immSuitabilityTest.get(
            'isFetchingHistoricalTests',
        );

        return !isFetchingHistoricalTests && this.isExpired() ? (
            <div className="ra-suitability-test-status__retake-test">
                <OKButton onClick={this.handleRetakeTestButtonClick}>
                    <FormattedText value="raSuitabilityTestStatus-retakeTest" />
                </OKButton>
                ;
            </div>
        ) : null;
    }

    render() {
        const { immFlagBasedFeatures } = this.props;
        const breadcrumb = this.buildBreadcrumb();
        const headerTitle = formatText('raSuitabilityTestStatus-headerTitle');
        const content = this.buildContent();
        const helpContent = !immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST)
            ? this.buildHelpContent()
            : null;
        const coverRightContent = this.buildCoverRightContent();

        return (
            <div className="grid-view ra-suitability-test-status">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            success={false}
                            showHelp={!!helpContent}
                            helpContent={helpContent}
                            successTitle=""
                            breadcrumb={breadcrumb}
                            title={headerTitle}
                            rightContent={coverRightContent}
                        />
                    </div>
                    <div className="row">{content}</div>
                </div>
            </div>
        );
    }
}

RASuitabilityTestStatusView.propTypes = {
    history: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immRAGlobalPosition: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    buttonRenewClicked: PropTypes.func.isRequired,
    enableRetryTest: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    getHistoricalTest: PropTypes.func.isRequired,
    setOrigin: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immCheckStatus: state.raCheckStatus,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immRAFeatureFlag: state.raFeatureFlag,
        immRAGlobalPosition: state.raGlobalPosition,
        immProfile: state.profile,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    {
        buttonRenewClicked: raSuitabilityTestActions.buttonRenewClicked,
        enableRetryTest: raSuitabilityTestActions.enableRetryTest,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        getHistoricalTest: raSuitabilityTestActions.getHistoricalTest,
        setOrigin: raSuitabilityTestActions.setOrigin,
    },
)(withRouter(RASuitabilityTestStatusView));
